import { z } from 'zod';
import { AllowedWebsiteSchemaIPG } from '../../../backend_config.types';
import {
    CloverOAuthAuthorizationState,
    type CloverOAuthAuthorizationStatus,
    type StartCloverOAuthReauthorizationRequest,
    type StartCloverOAuthReauthorizationResponse,
} from '../../../types/ipg/clover/clover-oauth.types';

export const CloverOAuthAuthorizationStatusSchema: z.ZodType<CloverOAuthAuthorizationStatus> = z
    .object({
        state: z.enum([
            CloverOAuthAuthorizationState.NOT_CONNECTED,
            CloverOAuthAuthorizationState.ACTIVE,
            CloverOAuthAuthorizationState.REAUTHORIZATION_REQUIRED,
            CloverOAuthAuthorizationState.DISCONNECTED,
        ]),
        access_token_expires_ts: z.string().datetime().nullable(),
        refresh_token_expires_ts: z.string().datetime().nullable(),
    })
    .strict();

export const StartCloverOAuthReauthorizationRequestSchema: z.ZodType<StartCloverOAuthReauthorizationRequest> =
    z.object({ organization_uuid: z.string().uuid() }).strict();

export const StartCloverOAuthReauthorizationResponseSchema: z.ZodType<StartCloverOAuthReauthorizationResponse> =
    z
        .object({
            authorization_url: z.string().url(),
            expires_ts: z.string().datetime(),
            allowed_websites: z.array(AllowedWebsiteSchemaIPG),
        })
        .strict();
